import { render } from "./Search.vue?vue&type=template&id=0d89144b&scoped=true&ts=true"
import script from "./Search.ts?vue&type=script&lang=ts"
export * from "./Search.ts?vue&type=script&lang=ts"

import "./Search.scss?vue&type=style&index=0&id=0d89144b&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d89144b"]])

export default __exports__